import React, { useMemo } from 'react'

import { string } from 'prop-types'

import LazyAiSignInModal from 'Pods/LazyLoaded/AiSignInModal/LazyAiSignInModal'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import useAuthModalTrigger from './useAuthModalTrigger'

// Every /ai-3d-model-generator* page needs this mounted: the header Log in / Sign up
// buttons live in a separate UnifiedNavigation tree and, on these paths, publish
// AUTH_MODAL_EVENT instead of opening their own popover (see UserMenu GuestActions,
// whose regex matches the sub-paths too). Without a host those buttons do nothing.
function SignInModalHost({ locale = 'en' }) {
  const { signInModalMode, closeSignInModal } = useAuthModalTrigger()

  // Only LazyAiSignInModal consumes this; it reads `locale` to translate its copy
  // (see Pods/ThreeDStudio/Hooks/useTranslation).
  const pageContextValue = useMemo(() => ({ locale }), [locale])

  if (!signInModalMode) return null

  return (
    <ThreeDStudioPageContext.Provider value={pageContextValue}>
      <LazyAiSignInModal mode={signInModalMode} onClose={closeSignInModal} />
    </ThreeDStudioPageContext.Provider>
  )
}

SignInModalHost.propTypes = {
  locale: string,
}

export default SignInModalHost
